import React, {useState} from 'react';
import {Button, InputNumber, message, Modal, Radio} from 'antd';
import ReactDOM from "react-dom";
import NHFetch from "../../../../../utils/NHFetch";

/**
 * 山东现代统一支付平台对应自足报道环节 GD008_1
 * @type {string}
 */

export default function shandongModernPay(xsxx) {

    let zzbdhjid = getQueryString('pkid');

    function showModal(resolve, estimateTextBookFee, estimateNoTextBookFee) {
        const div = document.createElement('div');
        document.body.appendChild(div);
        let isUnmounted = false;

        ReactDOM.render(
            <PayModal isUnmounted={isUnmounted}
                      resolve={resolve}
                      div={div}
                      xsxx={xsxx}
                      estimateTextBookFee={estimateTextBookFee}
                      estimateNoTextBookFee={estimateNoTextBookFee}
                      zzbdhjid={zzbdhjid}
            />,
            div
        );

        return () => {
            isUnmounted = true;
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
        };
    }

    function computeFee(feeArr, isTextBookFee) {
        if (feeArr?.length <= 0)
            return 0.0;

        console.log(">>>>>>>>>> feeArr", feeArr);
        let feeInCents  = 0.0;
        for (let feeItem of feeArr) {
            console.log(">>>>>>>>>> feeItem", feeItem);
            if (
                (isTextBookFee && feeItem?.sfxmmc == '教材费' || !isTextBookFee && feeItem?.sfxmmc != '教材费')
                && feeItem.qfje > 0
            ) {
                feeInCents += Math.round(feeItem.qfje * 100);
            }
        }
        return feeInCents  / 100;
    }

    function getQueryString(name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    }

    return new Promise((resolve) => {

        NHFetch('/jfxt/queryPayListByDataBase', 'GET').then(res => {
            if (res?.code === 200 && res.data?.length > 0) {
                /**
                 * 预估教材费和非教材费
                 */
                let estimateTextBookFee = computeFee(res.data, true);
                let estimateNoTextBookFee = computeFee(res.data, false);
                console.log(">>>>>> estimateTextBookFee", estimateTextBookFee)
                console.log(">>>>>> estimateNoTextBookFee", estimateNoTextBookFee)
                showModal(resolve, estimateTextBookFee, estimateNoTextBookFee);
            }
        });
    });
}

const TEXTBOOKMSG = "教材费需要一次性缴清";
const NOTEXTBOOKMSG = "缴费金额需要大于0(若已选宿舍, 则需大于住宿费), 小于欠费金额";
function PayModal({isUnmounted, resolve, div, xsxx, estimateTextBookFee, estimateNoTextBookFee, zzbdhjid}) {

    const [msg, setMsg] = useState(TEXTBOOKMSG);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({ type: 0, fee: estimateTextBookFee});

    function handleOk() {
        if (data?.fee <= 0) {
            message.warn("缴费金额需要大于0！！！");
            return
        }
        if (data.type === undefined) {
            message.warn("缴费类型不能为空！！！");
            return
        }

        setLoading(true);

        console.log(">>>>> xsxx", xsxx);
        let params = {
            fee: data.fee,
            payType: data.type,
            studentId: xsxx.DSFZH,
            zzbdhjid:zzbdhjid
        }

        NHFetch('/payFee/pay', 'POST', params).then(res => {
            if (!(res && res.code === 200 && res.data)) {
                return;
            }
            message.success("即将跳珠支付页面。。。");
            let payUrl = res.data;
            window.open(payUrl, '_blank');

            if (isUnmounted)
                return;
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
            resolve({ action: 'ok' });
        }).finally(() => {
            setLoading(false);
        })
    }

    function handleCancel() {
        if (!isUnmounted) {
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
            resolve({ action: 'cancel' });
        }
    }

    return (
        <div>
            <Modal
                title="网上缴费"
                visible={true}
                // onOk={handleOk}
                onCancel={handleCancel}
                // centered
                footer={[
                    <div key="footer" style={{display: 'flex', justifyContent: 'center'}}>
                        <Button disabled={data?.fee <= 0} type="primary" loading={loading} onClick={handleOk}>
                            支付
                        </Button>
                    </div>
                ]}
            >
                <span style={{color: 'red'}}> 温馨提示：{msg}</span>
                <br/>
                <br/>
                <span style={{color: 'red'}}>*</span>缴费类型：
                <Radio.Group onChange={e => {
                    let val = e.target.value
                    setData({...data, type: val})
                    if (val == '0') {
                        setMsg(TEXTBOOKMSG);
                    }
                    if (val == '1') {
                        setMsg(NOTEXTBOOKMSG);
                    }
                }} value={data.type} >
                    <Radio value={0}>教材费</Radio>
                    <Radio value={1}>住宿费,学费</Radio>
                </Radio.Group>
                <br/>
                <br/>
                <span style={{color: 'red'}}>*</span>缴费金额：
                <InputNumber min={0} max={999999} step={0.01} value={data.fee} onChange={(val) => {
                    setData({...data, fee: val})
                }}/> 元
                {data.type === 0 &&
                    <span style={{color: 'red', fontSize: '12px'}}>（预估教材费：{estimateTextBookFee}元 <a
                        onClick={() => {
                            setData({...data, fee: estimateTextBookFee})
                        }}>点击填入</a>）</span>
                }
                {data.type === 1 &&
                    <span style={{color: 'red', fontSize: '12px'}}>（预估费住宿费,学费：{estimateNoTextBookFee}元 <a
                        onClick={() => {
                            setData({...data, fee: estimateNoTextBookFee})
                        }}>点击填入</a>）</span>
                }
            </Modal>
        </div>
    );
}
